import posthog from "posthog-js";

const initializePostHog = async () => {
  const posthogKey = process.env.REACT_APP_POSTHOG_KEY?.trim();
  const posthogHost = process.env.REACT_APP_POSTHOG_HOST?.trim();
  
  console.log('🔍 PostHog Initialization Check:');
  console.log('- Key:', posthogKey);
  console.log('- Host:', posthogHost);
  console.log('- Final API host will be:', posthogHost);

  if (!posthogKey) {
    console.warn('⚠️ PostHog key is missing - PostHog will not initialize');
    return;
  }

  try {
    const config = {
      api_host: posthogHost || 'https://us.i.posthog.com',
      person_profiles: 'always', // Create person profiles for all users, including anonymous
      capture_pageview: true,
      autocapture: true,
      debug: process.env.NODE_ENV === 'development',
      loaded: (posthog) => {
        console.log('🎯 PostHog loaded callback triggered');
        console.log('- Person profiles mode:', 'always');
        console.log('- PostHog instance:', posthog);
        
        // Ensure session recordings use the same user ID as events
        if (typeof posthog.startSessionRecording === 'function') {
          posthog.startSessionRecording();
          console.log('📹 Session recording started');
        }
        
        // Check if user is already logged in and force identification
        const currentUserId = localStorage.getItem("customUserId");
        if (currentUserId) {
          console.log('🔄 Found existing user, re-identifying:', currentUserId);
          // Force identification on PostHog load
          posthog.identify(currentUserId);
        } else {
          // Generate anonymous ID and create profile
          const anonymousId = posthog.get_distinct_id();
          console.log('👤 Creating anonymous person profile:', anonymousId);
          posthog.setPersonProperties({
            anonymous_user: true,
            first_seen: new Date().toISOString(),
            user_type: 'anonymous'
          });
        }
      }
    };
    
    console.log('🔧 PostHog Config:', config);
    
    posthog.init(posthogKey, config);
    
    // Ensure PostHog is available globally for debugging
    window.posthog = posthog;

    console.log('✅ PostHog initialized successfully');
    
    // Test PostHog availability after initialization
    setTimeout(() => {
      console.log('🧪 PostHog Test After Init:');
      console.log('- window.posthog exists:', !!window.posthog);
      console.log('- posthog object:', window.posthog);
      console.log('- posthog._loaded:', window.posthog?._loaded);
      console.log('- posthog.has_opted_out_capturing:', window.posthog?.has_opted_out_capturing?.());
    }, 2000);
    
  } catch (error) {
    console.error('❌ PostHog initialization failed:', error);
    console.error('Error details:', error.message, error.stack);
  }

  const userInfoStr = localStorage.getItem("userInfo");
  if (!userInfoStr) return;

  try {
    const userInfo = JSON.parse(userInfoStr);
    const userId = userInfo?.data?.id;
    const phone = userInfo?.data?.phone;

    if (userId) {
      // 👤 Identify user with comprehensive profile data
      const userProfile = {
        phone_number: phone || "",
        user_id: userId.toString(),
        email: userInfo?.data?.email || "",
        name: userInfo?.data?.name || userInfo?.data?.first_name || "",
        account_status: userInfo?.data?.status || "unknown",
        registration_date: userInfo?.data?.created_at || "",
        level: userInfo?.data?.level || 0,
        xp: userInfo?.data?.xp || 0,
        coins: userInfo?.data?.token || 0,
        // Add any other user properties you want to track
      };

      // First identify the user to create/update their person profile
      posthog.identify(userId.toString(), userProfile);
      
      // Set person properties (use correct PostHog JS method)
      posthog.setPersonProperties(userProfile);
      
      // Force profile creation by capturing an identification event
      posthog.capture('user_profile_created', {
        user_id: userId.toString(),
        profile_data: userProfile,
        created_at: new Date().toISOString()
      });

      console.log('👤 PostHog user identified and profile created:', {
        userId: userId.toString(),
        profile: userProfile
      });
    }
  } catch (e) {
    console.error("Failed to parse userInfo from localStorage", e);
  }
};

export default initializePostHog;
